import React from 'react';
import { motion } from 'framer-motion';
interface ContentSectionProps {
  id: string;
  title?: string;
  children: React.ReactNode;
  className?: string;
}
export function ContentSection({
  id,
  title,
  children,
  className = ''
}: ContentSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.5
  }} className={`mb-12 scroll-mt-32 ${className}`} data-id="element-88">
      {title && <h2 className="text-3xl font-bold text-slate-900 mb-6 relative inline-block" data-id="element-89">
          {title}
          <span className="absolute -bottom-2 left-0 w-1/3 h-1 bg-gradient-to-r from-purple-600 to-red-500 rounded-full" data-id="element-90"></span>
        </h2>}
      <div className="text-lg text-slate-700 leading-relaxed" data-id="element-91">{children}</div>
    </motion.section>;
}